import { post } from "@rails/request.js";

/**
 * Finalize a contribution by calling its finalizeUrl.
 *
 * @param {string} finalizeUrl - The URL for finalizing the contribution.
 * @param {Function} onError - Callback for handling errors.
 */
export const finalizeCommentable = async (finalizeUrl, onError = console.error) => {
  try {
    const response = await post(finalizeUrl, {
      responseKind: "turbo-stream"
    });

    if (!response.ok) {
      throw new Error(`${response.statusText}`);
    }
  } catch (error) {
    onError(error);
  }
};
